import React from 'react';
import PropTypes from 'prop-types';
import { makeResetStyles, mergeClasses, shorthands } from '@fluentui/react-components';
import { MessageBar, MessageBarBody } from '@fluentui/react-message-bar';


const useBackgroundChangeDisclaimerStyles = makeResetStyles({
  position: 'absolute',
  top: '0',
  width: '100%',
  ...shorthands.padding('0', '8px'),
});

export const BackgroundChangeDisclaimer = (props) => {
  const {
    i18n,
  } = props;

  const classes = useBackgroundChangeDisclaimerStyles();

  return (
    <div className={mergeClasses('background-change-disclaimer', classes)}>
      <MessageBar key="info" intent="info">
        <MessageBarBody>
          {i18n.getString(_TL_('Note that AI-generated content may not always be accurate. Please double-check, crop, and verify AI-generated content before using it.'))}
        </MessageBarBody>
      </MessageBar>
    </div>);
};


BackgroundChangeDisclaimer.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

BackgroundChangeDisclaimer.defaultProps = {
};
